"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _reactDragDropContainer = require("react-drag-drop-container");

var _reactComponents = require("@cimpress/react-components");

var _ExpansionPanel = _interopRequireDefault(require("@material-ui/core/ExpansionPanel"));

var _ExpansionPanelSummary = _interopRequireDefault(require("@material-ui/core/ExpansionPanelSummary"));

var _ExpansionPanelDetails = _interopRequireDefault(require("@material-ui/core/ExpansionPanelDetails"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _agGridReact = require("ag-grid-react");

require("ag-grid/dist/styles/ag-grid.css");

require("ag-grid/dist/styles/ag-theme-balham.css");

var _PriceCellRenderer = _interopRequireDefault(require("./PriceCellRenderer"));

var _util = require("./services/util");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  height: 273px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  height: 195px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var attributeListWithoutQuantity = (0, _emotion.css)(_templateObject());
var attributeListWithQuantity = (0, _emotion.css)(_templateObject2());

var PivotConfigurationPanel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PivotConfigurationPanel, _Component);

  function PivotConfigurationPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PivotConfigurationPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PivotConfigurationPanel).call(this, props)); // Retrieve the last state

    _this.componentDidMount = function () {
      var initialize = _this.state.initialize;
      var selectedColumnChips = _this.state.selectedColumnChips;
      var clonedOptions = _this.state.clonedOptions;
      var _this$props = _this.props,
          onUpdateSelectedRowColumns = _this$props.onUpdateSelectedRowColumns,
          options = _this$props.options,
          results = _this$props.results;

      if (!initialize && (clonedOptions.length !== options.length || !(0, _isEqual.default)(clonedOptions, options))) {
        initialize = true;
      }

      if (initialize) {
        clonedOptions = (0, _util.deepClone)(_this.props.options);
        var attributesOriginalList = (0, _util.deepClone)(options);
        attributesOriginalList = attributesOriginalList.map(function (obj) {
          if (obj.isRange) {
            obj.selectedValues = obj.defaults.sort(function (a, b) {
              return a - b;
            });
          } else if (obj.values && (obj.values.length <= 10 || obj.key.toLowerCase() === 'quantity')) {
            _this.sort(obj.values);

            obj.selectedValues = obj.values;
          } else {
            _this.sort(obj.values);

            _this.sort(obj.defaults);

            obj.selectedValues = obj.defaults;
          }

          if (obj.values && !obj.isRange) {
            obj.values = _this.filterArray(obj.values, obj.selectedValues);
          }

          return obj;
        });

        _this.sort(attributesOriginalList, 'key');

        var attributesDraggableList = attributesOriginalList.map(function (option) {
          option.label = (0, _util.capitalize)(option.key);
          option.value = option.key;
          return option;
        });

        var selectedRowChips = _this.getInitialRow(attributesDraggableList);

        attributesDraggableList = attributesDraggableList.filter(function (option) {
          return option.label.toLowerCase() !== 'quantity';
        });

        _this.sort(attributesDraggableList, 'label');

        var selectedRow = !(0, _util.isEmptyArray)(selectedRowChips) ? selectedRowChips[0] : null;
        onUpdateSelectedRowColumns(selectedRow, selectedColumnChips);
        var attributeFilterArray = selectedColumnChips && selectedRowChips && selectedColumnChips.concat(selectedRowChips);
        var selectedAttributeValues = [];
        var selectedAttributeInFilter;

        if (attributeFilterArray.length === 1) {
          var _attributeFilterArray = (0, _slicedToArray2.default)(attributeFilterArray, 1);

          selectedAttributeInFilter = _attributeFilterArray[0];
          selectedAttributeValues = selectedAttributeInFilter.selectedValues;
        }

        var selected = null;
        var dropdownOptions = [];

        if (_this.props.showDropdown) {
          dropdownOptions = results && results.headers ? Object.keys(results.headers) : [];
          selected = dropdownOptions.length > 0 ? dropdownOptions[0] : null;
        }

        var isRowSelected = selectedRowChips && selectedRowChips.length > 0;
        var isColumnSelected = selectedColumnChips && selectedColumnChips.length > 0;

        _this.setRowData(isRowSelected, isColumnSelected);

        _this.setState({
          attributesOriginalList: attributesOriginalList,
          attributesDraggableList: attributesDraggableList,
          selectedRowChips: selectedRowChips,
          selectedAttributeInFilter: selectedAttributeInFilter,
          attributeFilterArray: attributeFilterArray,
          selectedAttributeValues: selectedAttributeValues,
          initialize: false,
          columnArray: _this.getPivotingColumns(isRowSelected, selected),
          dropdownOptions: dropdownOptions,
          selected: selected,
          isRowSelected: isRowSelected,
          isColumnSelected: isColumnSelected,
          clonedOptions: clonedOptions
        });
      }
    };

    _this.componentWillUnmount = function () {
      _this.props.changePivotLayoutState(_this.state);
    };

    _this.onQuantityChange = function (event) {
      var attributesOriginalList = _this.state.attributesOriginalList;
      var value = parseFloat(event.target.value);
      var quantity = attributesOriginalList.find(function (item) {
        return item.key.toLowerCase() === 'quantity';
      });

      if (quantity) {
        var isValid = _this.validateRange(quantity, value);

        if (isValid) {
          _this.setState({
            selectedQuantity: event.target.value,
            quantityHelpText: null,
            quantityStyle: null
          }, function () {
            return _this.props.onQuantityChange(_this.state.selectedQuantity);
          });
        } else {
          _this.setState({
            selectedQuantity: event.target.value,
            quantityHelpText: 'Enter a valid input',
            quantityStyle: 'error'
          });
        }
      }
    };

    _this.onSelectedConfigAttributeChange = function (selectedAttributeInFilter) {
      _this.setState({
        selectedAttributeInFilter: selectedAttributeInFilter
      });
    };

    _this.onSelectedListValuesChange = function (selected) {
      var selectedAttributeValues = _this.state.selectedAttributeValues;
      var selectedAttributeInFilter = _this.state.selectedAttributeInFilter;
      selectedAttributeValues = (0, _util.deepClone)(selectedAttributeValues);
      var listValuesHelpText = null;

      if (selected) {
        if (selectedAttributeValues.length <= 10) {
          if (!selectedAttributeValues.find(function (value) {
            return value === selected.label;
          })) {
            selectedAttributeValues.push(selected.label); // this.sort(selectedAttributeValues);

            if (!selectedAttributeInFilter.isRange) {
              selectedAttributeInFilter.values = selectedAttributeInFilter.values.filter(function (value) {
                return value !== selected.label;
              });
            }

            selectedAttributeInFilter.selectedValues = selectedAttributeValues;

            _this.changeSelectedValues(selectedAttributeValues);

            _this.setState({
              selectedAttributeValues: selectedAttributeValues,
              selectedAttributeInFilter: selectedAttributeInFilter
            });
          } else {
            listValuesHelpText = 'Value already selected';
          }
        } else {
          listValuesHelpText = 'Maximum Values Allowed : 10';
        }
      }

      _this.setState({
        inputListValue: selected,
        listValuesHelpText: listValuesHelpText
      });
    };

    _this.onSelectedRangeValuesChange = function (event) {
      var _this$state = _this.state,
          selectedAttributeInFilter = _this$state.selectedAttributeInFilter,
          selectedAttributeValues = _this$state.selectedAttributeValues;
      var inputValue = parseFloat(event.target.value);

      _this.setState({
        inputRangeValue: inputValue
      });

      if (inputValue) {
        if (selectedAttributeInFilter.key.toLowerCase() !== 'quantity' && selectedAttributeValues.length === 10) {
          _this.setState({
            rangeValuesHelpText: 'Maximum 10 selections allowed',
            inputRangeStyle: 'error'
          });
        } else if (selectedAttributeValues.find(function (value) {
          return value === inputValue;
        })) {
          _this.setState({
            rangeValuesHelpText: 'Value already selected',
            inputRangeStyle: 'error'
          });
        } else {
          var isValid = _this.validateRange(selectedAttributeInFilter, inputValue);

          if (isValid) {
            _this.setState({
              inputRangeStyle: 'success',
              rangeValuesHelpText: null
            });
          } else {
            _this.setState({
              rangeValuesHelpText: 'Enter a valid input',
              inputRangeStyle: 'error'
            });
          }
        }
      } else {
        _this.setState({
          rangeValuesHelpText: null,
          inputRangeStyle: null
        });
      }
    };

    _this.onRemoveSelectedValueChip = function (chip) {
      var _this$state2 = _this.state,
          selectedAttributeValues = _this$state2.selectedAttributeValues,
          selectedValuesHelpText = _this$state2.selectedValuesHelpText;
      var selectedAttributeInFilter = _this.state.selectedAttributeInFilter;
      var saveQuantities = _this.props.saveQuantities;

      if (selectedAttributeValues.length < 2) {
        selectedValuesHelpText = 'Minimum 1 selection is required';

        _this.setState({
          selectedValuesHelpText: selectedValuesHelpText
        });
      } else {
        selectedAttributeValues = (0, _util.deepClone)(selectedAttributeValues);
        var index = selectedAttributeValues.indexOf(chip);
        selectedAttributeValues.splice(index, 1);
        if (selectedAttributeInFilter.key.toLowerCase() === 'quantity') saveQuantities(selectedAttributeValues);

        if (!selectedAttributeInFilter.isRange) {
          selectedAttributeInFilter.values.push(chip); // this.sort(selectedAttributeInFilter.values);
        }

        selectedAttributeInFilter.selectedValues = selectedAttributeValues;

        _this.changeSelectedValues(selectedAttributeValues);

        _this.setState({
          selectedAttributeInFilter: selectedAttributeInFilter,
          selectedAttributeValues: selectedAttributeValues
        });
      }
    };

    _this.onDropdownSelection = function (value) {
      _this.setState({
        selected: value
      });
    };

    _this.onGridReady = function (params) {
      _this.gridApi = params.api;

      _this.gridApi.sizeColumnsToFit();

      if (_this.state.rowData === null) {
        _this.gridApi.showLoadingOverlay();
      }
    };

    _this.onSelectionChanged = function (params) {
      params.api.sizeColumnsToFit();
    };

    _this.onDisplayedColumnsChanged = function (params) {
      params.api.sizeColumnsToFit();
      var displayedColumns = params.columnApi.getDisplayedCenterColumns();
      var orderedColumns = displayedColumns.map(function (obj) {
        return obj.getColDef().headerName;
      });
      var _this$state3 = _this.state,
          selectedColumnChips = _this$state3.selectedColumnChips,
          attributeFilterArray = _this$state3.attributeFilterArray,
          selectedAttributeInFilter = _this$state3.selectedAttributeInFilter;
      var selectedAttributeValues = _this.state.selectedAttributeValues;

      if (selectedColumnChips && selectedColumnChips.length > 0) {
        if (orderedColumns.length < selectedColumnChips[0].selectedValues.length) {
          var removedChip = selectedColumnChips[0].selectedValues.filter(function (value) {
            return orderedColumns.indexOf(value) === -1;
          });
          selectedColumnChips[0].values.push(removedChip);
        }

        selectedColumnChips[0].selectedValues = orderedColumns;
        var changeSelectedValues = attributeFilterArray.find(function (attribute) {
          return selectedColumnChips[0].label.toLowerCase() === attribute.label.toLowerCase();
        });

        if (selectedAttributeInFilter && changeSelectedValues && selectedAttributeInFilter.label.toLowerCase() === changeSelectedValues.label.toLowerCase()) {
          selectedAttributeValues = orderedColumns;
        }

        _this.setState({
          selectedColumnChips: selectedColumnChips,
          attributeFilterArray: attributeFilterArray,
          selectedAttributeValues: selectedAttributeValues
        });
      }
    };

    _this.setRowData = function (isRowSelected, isColumnSelected) {
      var results = _this.props.results;
      var rowData = null;

      if (results && results.rowData && results.rowData.length > 0) {
        rowData = results.rowData;
      } else if (!(isRowSelected || isColumnSelected)) {
        rowData = [];
      }

      if (rowData) {
        _this.setState({
          rowData: rowData
        });

        return;
      }

      if (_this.gridApi) {
        _this.setState({
          rowData: null
        }, function () {
          return _this.gridApi.showLoadingOverlay();
        });

        setTimeout(function () {
          if (!_this.state.rowData) {
            _this.setState({
              rowData: []
            });
          }
        }, 25000);
      }
    };

    _this.getInitialRow = function (attributesDraggableList) {
      var selectedRowChips = [];
      var quantityChip = attributesDraggableList.find(function (option) {
        return option.label.toLowerCase() === 'quantity';
      });

      if (quantityChip) {
        selectedRowChips.push(quantityChip);
      }

      return selectedRowChips;
    };

    _this.setMaximumRowsHelpText = function () {
      var selectedRowChips = _this.state.selectedRowChips;

      if (selectedRowChips && selectedRowChips.length === 1) {
        _this.setState({
          maxSelectedRowsExceeded: 'Maximum 1 attribute allowed.'
        });

        return true;
      }

      _this.setState({
        maxSelectedRowsExceeded: null
      });

      return false;
    };

    _this.setMaximumColumnsHelpText = function () {
      var selectedColumnChips = _this.state.selectedColumnChips;

      if (selectedColumnChips && selectedColumnChips.length === 1) {
        _this.setState({
          maxSelectedColumnsExceeded: 'Maximum 1 attribute allowed.'
        });

        return true;
      }

      _this.setState({
        maxSelectedColumnsExceeded: null
      });

      return false;
    };

    _this.getPivotingColumns = function (isRowSelected, selected) {
      var columnsDefinition = [];
      var _this$props2 = _this.props,
          results = _this$props2.results,
          showDropdown = _this$props2.showDropdown;

      if (results && results.headers) {
        var headers = showDropdown && selected ? results.headers[selected] : results.headers;

        if (headers) {
          headers.forEach(function (val) {
            if (val.isParent === true) {
              var arChild = [];
              val.children.forEach(function (child) {
                arChild.push({
                  headerName: (0, _util.capitalize)(child.name),
                  field: "".concat(child.value),
                  minWidth: 120,
                  filter: 'agTextColumnFilter',
                  cellRendererFramework: _PriceCellRenderer.default,
                  // headerComponentFramework: PivotHeaderRenderer,
                  type: 'numericColumn'
                });
              });
              var parentWidth = arChild.length * 150;
              columnsDefinition.push({
                headerName: (0, _util.capitalize)(val.name),
                children: arChild,
                width: parentWidth,
                minWidth: 120
              });
            } else {
              var cell = {
                headerName: (0, _util.capitalize)(val.name),
                field: val.value,
                minWidth: 120,
                resizable: true,
                filter: 'agTextColumnFilter',
                cellRendererFramework: _PriceCellRenderer.default
              };

              if (columnsDefinition.length === 0 && isRowSelected) {
                cell.pinned = 'left';
                cell.lockPinned = true;
                cell.cellClass = 'pinnedCellStyle';
                cell.sortable = true;
                cell.unSortIcon = true;
                cell.rowDrag = true;
                cell.width = 200;
                cell.suppressSizeToFit = true;
                cell.suppressMovable = true;
              } else {
                cell.type = 'numericColumn'; // cell.headerComponentFramework = PivotHeaderRenderer;
              }

              columnsDefinition.push(cell);
            }
          });
        }
      }

      return columnsDefinition;
    };

    _this.dragWithinContainerStart = function (e) {
      _this.dragged = e.currentTarget;
      e.dataTransfer.effectAllowed = 'move';
      e.dataTransfer.setData('text/html', _this.dragged);
    };

    _this.dragWithinContainerEnd = function (e) {
      var _this$state4 = _this.state,
          selectedColumnChips = _this$state4.selectedColumnChips,
          selectedRowChips = _this$state4.selectedRowChips;
      selectedColumnChips = (0, _util.deepClone)(selectedColumnChips);
      selectedRowChips = (0, _util.deepClone)(selectedRowChips);
      _this.dragged.style.display = 'inline-flex';
      var draggedFromCategory = _this.dragged.dataset.category;
      var draggedToCategory = _this.over.dataset.category;
      var draggedFromContainer = _this.dragged.dataset.container;
      var draggedToContainer = _this.over.dataset.container;

      if (draggedFromCategory && draggedToCategory) {
        // swap between chips
        var draggedFromId = Number(_this.dragged.dataset.id);
        var draggedToId = Number(_this.over.dataset.id);

        if (draggedFromCategory !== draggedToCategory) {
          var rowChips = selectedRowChips;
          var colChips = selectedColumnChips;

          if (draggedFromCategory === 'row') {
            // drag row chip to column chip and swap them
            e.dataTransfer.setData('column', _this.dragged.dataset.category);
            e.dataTransfer.setData('row', _this.over.dataset.category);
            var deletedCol = colChips.splice(draggedToId, 1)[0];
            var deletedRow = rowChips.splice(draggedFromId, 1)[0];
            colChips.splice(draggedToId, 0, deletedRow);
            rowChips.splice(draggedFromId, 0, deletedCol);
          }

          if (draggedFromCategory === 'column') {
            // drag column chip to row chip and swap them
            e.dataTransfer.setData('row', _this.dragged.dataset.category);
            e.dataTransfer.setData('column', _this.over.dataset.category);
            var _deletedCol = colChips.splice(draggedFromId, 1)[0];
            var _deletedRow = rowChips.splice(draggedToId, 1)[0];
            colChips.splice(draggedFromId, 0, _deletedRow);
            rowChips.splice(draggedToId, 0, _deletedCol);
          }

          _this.setState({
            selectedColumnChips: colChips,
            selectedRowChips: rowChips
          });
        } else if (draggedFromCategory === 'column' && draggedFromId !== draggedToId) {
          // swap among the column chips
          var data = selectedColumnChips;

          if (draggedFromId < draggedToId) {
            draggedToId -= 1;
          }

          var deletedChip = data.splice(draggedFromId, 1)[0];
          data.splice(draggedToId, 0, deletedChip);

          _this.setState({
            selectedColumnChips: data
          });
        }
      } else if (draggedFromContainer === 'chips') {
        if (draggedFromCategory === 'row' && draggedToContainer === 'column-box') {
          // drag a row chip to column box for adding to column list and delete chip from row list
          var maxColumnsExceeded = _this.setMaximumColumnsHelpText();

          if (!maxColumnsExceeded) {
            _this.setMaximumColumnsHelpText(false);

            var chip = JSON.parse(_this.dragged.dataset.value);
            selectedColumnChips.push(chip);
            var index = selectedRowChips.indexOf(chip);
            selectedRowChips.splice(index, 1);

            _this.setState({
              selectedColumnChips: selectedColumnChips,
              selectedRowChips: selectedRowChips
            });
          }
        }

        if (draggedFromCategory === 'column' && draggedToContainer === 'row-box') {
          // drag a column chip to row box for adding to row list and delete chip from row list
          var maxRowsExceeded = _this.setMaximumRowsHelpText();

          if (!maxRowsExceeded) {
            _this.setMaximumRowsHelpText(false);

            var _chip = JSON.parse(_this.dragged.dataset.value);

            selectedRowChips.push(_chip);

            var _index = selectedColumnChips.indexOf(_chip);

            selectedColumnChips.splice(_index, 1);

            _this.setState({
              selectedColumnChips: selectedColumnChips,
              selectedRowChips: selectedRowChips
            });
          }
        }
      }
    };

    _this.handleChipDelete = function (data, type) {
      _this.setState(function (state) {
        var selectedRowChips = state.selectedRowChips,
            selectedColumnChips = state.selectedColumnChips,
            selectedAttributeInFilter = state.selectedAttributeInFilter;
        var attributesDraggableList = state.attributesDraggableList,
            attributeFilterArray = state.attributeFilterArray;

        if (type === 'row') {
          selectedRowChips = (0, _toConsumableArray2.default)(selectedRowChips);
          var chipToDelete = selectedRowChips.indexOf(data);
          if (chipToDelete > -1) selectedRowChips.splice(chipToDelete, 1);
        }

        if (type === 'column') {
          selectedColumnChips = (0, _toConsumableArray2.default)(selectedColumnChips);

          var _chipToDelete = selectedColumnChips.indexOf(data);

          if (_chipToDelete > -1) selectedColumnChips.splice(_chipToDelete, 1);
        }

        var indexAttribute = attributeFilterArray.indexOf(data);
        attributeFilterArray.splice(indexAttribute, 1);
        if (selectedAttributeInFilter && selectedAttributeInFilter.key.toLowerCase() === data.key.toLowerCase()) selectedAttributeInFilter = null;
        attributesDraggableList.indexOf(data) === -1 && attributesDraggableList.push(data);

        _this.sort(attributesDraggableList, 'label');

        return {
          selectedRowChips: selectedRowChips,
          selectedColumnChips: selectedColumnChips,
          attributesDraggableList: attributesDraggableList,
          selectedAttributeInFilter: selectedAttributeInFilter,
          attributeFilterArray: attributeFilterArray
        };
      });
    };

    _this.handleRowChipDelete = function (data) {
      return function () {
        _this.handleChipDelete(data, 'row');
      };
    };

    _this.handleColumnChipDelete = function (data) {
      return function () {
        _this.handleChipDelete(data, 'column');
      };
    };

    _this.sort = function (array, key) {
      return array.sort(function (a, b) {
        var x = key ? a[key] : a;
        var y = key ? b[key] : b;
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
      });
    };

    _this.handleDrop = function (valueData, type) {
      var _this$state5 = _this.state,
          attributesDraggableList = _this$state5.attributesDraggableList,
          selectedRowChips = _this$state5.selectedRowChips,
          selectedColumnChips = _this$state5.selectedColumnChips;
      var attributeFilterArray = _this.state.attributeFilterArray;
      attributeFilterArray.push(valueData);
      var selectedAttributeInFilter = valueData;

      if (type === 'row') {
        selectedRowChips = (0, _toConsumableArray2.default)(selectedRowChips);
        selectedRowChips.push(valueData);
      } else if (type === 'column') {
        selectedColumnChips = (0, _toConsumableArray2.default)(selectedColumnChips);
        selectedColumnChips.push(valueData);
      }

      attributesDraggableList = attributesDraggableList.filter(function (_ref) {
        var label = _ref.label;
        return label.toLowerCase() !== valueData.label.toLowerCase();
      });

      _this.setState({
        attributesDraggableList: attributesDraggableList,
        selectedRowChips: selectedRowChips,
        selectedColumnChips: selectedColumnChips,
        selectedAttributeInFilter: selectedAttributeInFilter,
        attributeFilterArray: attributeFilterArray
      });
    };

    _this.handleDropRow = function (event) {
      var valueData = event.dragData;

      if (!_this.setMaximumRowsHelpText()) {
        _this.handleDrop(valueData, 'row');
      }
    };

    _this.handleDropColumn = function (e) {
      var valueData = e.dragData;

      if (!_this.setMaximumColumnsHelpText()) {
        _this.handleDrop(valueData, 'column');
      }
    };

    _this.handlePanelExpansion = function () {
      _this.setState({
        panelExpanded: !_this.state.panelExpanded
      });
    };

    _this.countDecimals = function (num) {
      if (num && Math.floor(num) !== num) return num.toString().split('.')[1].length || 0;
      return 0;
    };

    _this.validateRange = function (selectedAttributeInFilter, value) {
      var _selectedAttributeInF = selectedAttributeInFilter.values,
          ranges = _selectedAttributeInF.ranges,
          fixedValues = _selectedAttributeInF.fixedValues;
      var isFixedValue = fixedValues ? fixedValues.indexOf(value) > -1 : false;
      var isWithinRange = false;

      for (var i = 0; i < ranges.length; i += 1) {
        var _ranges$i = ranges[i],
            minimum = _ranges$i.minimum,
            maximum = _ranges$i.maximum,
            increment = _ranges$i.increment;

        var incrementDecimalCount = _this.countDecimals(increment);

        var multiplier = Math.pow(10, incrementDecimalCount);

        if (value >= minimum && value <= maximum) {
          var remainder = (value * multiplier - minimum * multiplier) / increment * multiplier;
          isWithinRange = Math.round(remainder) - remainder === 0;
        }

        if (isWithinRange) {
          break;
        }
      }

      return isFixedValue || isWithinRange;
    };

    _this.updateIfRowAndColumnSelected = function () {
      var _this$state6 = _this.state,
          selectedRowChips = _this$state6.selectedRowChips,
          selectedColumnChips = _this$state6.selectedColumnChips;
      var isRowSelected = selectedRowChips && selectedRowChips.length > 0;
      var isColumnSelected = selectedColumnChips && selectedColumnChips.length > 0;

      _this.onRowSelection(isRowSelected);

      _this.onColumnSelection(isColumnSelected);
    };

    _this.dragOver = function (e) {
      e.preventDefault();
      _this.dragged.style.display = 'none';
      if (e.target.className === 'placeholder') return;
      _this.over = e.target;
    };

    _this.addInputToSelectedRangeValues = function () {
      var saveQuantities = _this.props.saveQuantities;
      var _this$state7 = _this.state,
          inputRangeValue = _this$state7.inputRangeValue,
          selectedAttributeInFilter = _this$state7.selectedAttributeInFilter;
      var selectedAttributeValues = _this.state.selectedAttributeValues;
      selectedAttributeValues = (0, _util.deepClone)(selectedAttributeValues);
      selectedAttributeValues.push(inputRangeValue);
      selectedAttributeValues.sort(function (a, b) {
        return a - b;
      });
      if (selectedAttributeInFilter.key.toLowerCase() === 'quantity') saveQuantities(selectedAttributeValues);
      selectedAttributeInFilter.selectedValues = selectedAttributeValues;

      _this.changeSelectedValues(selectedAttributeValues);

      _this.setState({
        selectedAttributeValues: selectedAttributeValues,
        selectedAttributeInFilter: selectedAttributeInFilter
      });
    };

    _this.changeSelectedValues = function (selectedAttributeValues) {
      var _this$state8 = _this.state,
          selectedRowChips = _this$state8.selectedRowChips,
          selectedColumnChips = _this$state8.selectedColumnChips;
      var selectedAttributeInFilter = _this.state.selectedAttributeInFilter;
      var selectedRowValuesArray = selectedRowChips.find(function (row) {
        return row.key.toLowerCase() === selectedAttributeInFilter.value.toLowerCase();
      });

      if (selectedRowValuesArray) {
        selectedRowValuesArray.selectedValues = selectedAttributeValues;
      } else {
        var selectedColumnValuesArray = selectedColumnChips.find(function (column) {
          return column.key.toLowerCase() === selectedAttributeInFilter.value.toLowerCase();
        });

        if (selectedColumnValuesArray) {
          selectedColumnValuesArray.selectedValues = selectedAttributeValues;
        }
      }
    };

    _this.showQuantitySelection = function () {
      var _this$state9 = _this.state,
          selectedColumnChips = _this$state9.selectedColumnChips,
          selectedRowChips = _this$state9.selectedRowChips,
          showQuantity = _this$state9.showQuantity,
          selectedQuantity = _this$state9.selectedQuantity;
      var onQuantityVisibilityChange = _this.props.onQuantityVisibilityChange;

      if (selectedQuantity) {
        if ((selectedRowChips.length > 0 || selectedColumnChips.length > 0) && !selectedRowChips.find(function (row) {
          return row.key.toLowerCase() === 'quantity';
        }) && !selectedColumnChips.find(function (column) {
          return column.key.toLowerCase() === 'quantity';
        })) {
          if (!showQuantity) {
            _this.setState({
              showQuantity: true
            });

            onQuantityVisibilityChange(true, selectedQuantity);
          }
        } else if (showQuantity) {
          _this.setState({
            showQuantity: false
          });

          onQuantityVisibilityChange(false, selectedQuantity);
        }
      }
    };

    _this.filterArray = function (parentArray, childArray) {
      var array = parentArray.filter(function (value) {
        return childArray.indexOf(value) < 0;
      });
      return array;
    };

    _this.state = (0, _objectSpread2.default)({}, _this.props.pivotLayoutState, {
      selectedQuantity: _this.props.defaultQuantity
    });
    return _this;
  }

  (0, _createClass2.default)(PivotConfigurationPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$state10 = this.state,
          selectedRowChips = _this$state10.selectedRowChips,
          selectedColumnChips = _this$state10.selectedColumnChips,
          selectedAttributeInFilter = _this$state10.selectedAttributeInFilter;
      var _this$state11 = this.state,
          selected = _this$state11.selected,
          isRowSelected = _this$state11.isRowSelected,
          isColumnSelected = _this$state11.isColumnSelected;
      var _this$props3 = this.props,
          defaultQuantity = _this$props3.defaultQuantity,
          results = _this$props3.results,
          showDropdown = _this$props3.showDropdown;

      if (prevState.selected !== selected || !(0, _isEqual.default)(prevProps.results, results)) {
        var dropdownOptions = results && results.headers ? Object.keys(results.headers) : [];

        if (showDropdown) {
          if (selected === null && dropdownOptions.length > 0) {
            var _dropdownOptions = (0, _slicedToArray2.default)(dropdownOptions, 1);

            selected = _dropdownOptions[0];
          }
        }

        this.setState({
          dropdownOptions: dropdownOptions,
          selected: selected,
          columnArray: this.getPivotingColumns(isRowSelected, selected)
        });
        this.setRowData(isRowSelected, isColumnSelected);
      }

      if (prevProps.defaultQuantity !== defaultQuantity) {
        this.setState({
          selectedQuantity: defaultQuantity
        });
      }

      if (!(0, _isEqual.default)(prevState.selectedColumnChips, selectedColumnChips) || !(0, _isEqual.default)(prevState.selectedRowChips, selectedRowChips) || !(0, _isEqual.default)(prevState.selectedAttributeValues, this.state.selectedAttributeValues)) {
        this.showQuantitySelection();
        this.props.onUpdateSelectedRowColumns(this.state.selectedRowChips[0], this.state.selectedColumnChips);
        isRowSelected = selectedRowChips && selectedRowChips.length > 0;
        isColumnSelected = selectedColumnChips && selectedColumnChips.length > 0;
        this.setState({
          maxSelectedRowsExceeded: null,
          maxSelectedColumnsExceeded: null,
          rangeValuesHelpText: null,
          inputRangeStyle: null,
          listValuesHelpText: null,
          inputListValue: undefined,
          inputRangeValue: undefined,
          selectedValuesHelpText: null,
          isColumnSelected: isColumnSelected,
          isRowSelected: isRowSelected
        });
      }

      if (!(0, _isEqual.default)(prevState.selectedAttributeInFilter, selectedAttributeInFilter)) {
        if (selectedAttributeInFilter) {
          this.setState({
            selectedAttributeValues: selectedAttributeInFilter.selectedValues
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state12 = this.state,
          selectedColumnChips = _this$state12.selectedColumnChips,
          selectedRowChips = _this$state12.selectedRowChips,
          selectedAttributeInFilter = _this$state12.selectedAttributeInFilter,
          attributesDraggableList = _this$state12.attributesDraggableList,
          selectedAttributeValues = _this$state12.selectedAttributeValues,
          inputRangeValue = _this$state12.inputRangeValue,
          inputListValue = _this$state12.inputListValue,
          rangeValuesHelpText = _this$state12.rangeValuesHelpText,
          inputRangeStyle = _this$state12.inputRangeStyle,
          quantityHelpText = _this$state12.quantityHelpText,
          quantityStyle = _this$state12.quantityStyle,
          listValuesHelpText = _this$state12.listValuesHelpText,
          maxSelectedRowsExceeded = _this$state12.maxSelectedRowsExceeded,
          maxSelectedColumnsExceeded = _this$state12.maxSelectedColumnsExceeded,
          panelExpanded = _this$state12.panelExpanded,
          attributesOriginalList = _this$state12.attributesOriginalList,
          showQuantity = _this$state12.showQuantity,
          selectedQuantity = _this$state12.selectedQuantity,
          attributeFilterArray = _this$state12.attributeFilterArray,
          selectedValuesHelpText = _this$state12.selectedValuesHelpText,
          selected = _this$state12.selected,
          columnArray = _this$state12.columnArray,
          defaultColDef = _this$state12.defaultColDef,
          dropdownOptions = _this$state12.dropdownOptions,
          frameworkComponents = _this$state12.frameworkComponents,
          loadingOverlayComponent = _this$state12.loadingOverlayComponent;
      var showDropdown = this.props.showDropdown;
      var quantity = attributesOriginalList.find(function (item) {
        return item.key.toLowerCase() === 'quantity';
      });
      var quantityToolTip = showQuantity && quantity ? quantity.toolTip : null;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_ExpansionPanel.default, {
        expanded: panelExpanded,
        onChange: this.handlePanelExpansion,
        className: "expansion-panel"
      }, _react.default.createElement(_ExpansionPanelSummary.default, {
        className: "expansion-panel-summary",
        expandIcon: _react.default.createElement(_ExpandMore.default, null)
      }, _react.default.createElement("h6", null, "CONFIGURE PIVOTING")), _react.default.createElement(_ExpansionPanelDetails.default, null, _react.default.createElement("div", {
        className: "expansion-panel-details"
      }, _react.default.createElement("div", {
        className: "col-md-7"
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement(_Paper.default, {
        className: "pivot-panel-paper"
      }, _react.default.createElement("div", {
        className: "drag-drop-attributes"
      }, _react.default.createElement("div", {
        className: "col-md-5 fixed-attribute-list-style ".concat(showQuantity ? attributeListWithQuantity : attributeListWithoutQuantity)
      }, attributesDraggableList && attributesDraggableList.length > 0 ? _react.default.createElement(_List.default, {
        dense: true,
        className: "list-style-attributes"
      }, attributesDraggableList.map(function (val) {
        return _react.default.createElement(_reactDragDropContainer.DragDropContainer, {
          targetKey: "rowData",
          dragData: val,
          disappearDraggedElement: true
        }, _react.default.createElement(_ListItem.default, {
          button: true,
          key: val.label,
          className: "draggable-list",
          dense: true
        }, _react.default.createElement(_ListItemIcon.default, null, _react.default.createElement(_reactComponents.Icon, {
          color: colors.teal.base,
          name: "drag-drop-l",
          size: "1x"
        })), _react.default.createElement(_ListItemText.default, {
          primary: val.label,
          className: "pivot-item-style"
        })));
      })) : _react.default.createElement("div", {
        className: "no-attributes-style"
      }, ' ', "No attributes \n available for pivoting")), _react.default.createElement("div", {
        className: "col-md-6",
        style: {
          marginLeft: '3%',
          width: '100%'
        }
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "selection-box"
      }, _react.default.createElement(_reactDragDropContainer.DropTarget, {
        onHit: this.handleDropRow,
        targetKey: "rowData"
      }, _react.default.createElement("div", {
        onDragOver: this.dragOver
      }, _react.default.createElement("h6", null, "Select Row"), selectedRowChips && selectedRowChips.length > 0 ? _react.default.createElement("div", {
        className: "drag-chips-box-style",
        "data-container": "row-box"
      }, selectedRowChips.map(function (data, index) {
        return _react.default.createElement("div", {
          className: "chip-container"
        }, _react.default.createElement(_reactComponents.Tag, {
          value: data.label,
          "data-id": index,
          "data-value": JSON.stringify(data),
          "data-category": "row",
          "data-container": "chips",
          key: data.label,
          removable: true,
          draggable: "true",
          onRemoveClick: _this2.handleRowChipDelete(data),
          onDragEnd: _this2.dragWithinContainerEnd,
          onDragStart: _this2.dragWithinContainerStart,
          onDragOver: _this2.dragOver
        }));
      }), maxSelectedRowsExceeded ? _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "max-size-exceeded"
      }, maxSelectedRowsExceeded)) : null) : _react.default.createElement("div", {
        className: "drag-box",
        "data-container": "row-box"
      }, "Drag Here", _react.default.createElement("br", null), _react.default.createElement("span", {
        className: "drag-box-max"
      }, "(Max Allowed : 1)")))))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "selection-box"
      }, _react.default.createElement(_reactDragDropContainer.DropTarget, {
        onHit: this.handleDropColumn,
        targetKey: "rowData"
      }, _react.default.createElement("div", {
        onDragOver: this.dragOver
      }, _react.default.createElement("h6", null, "Select Columns"), selectedColumnChips && selectedColumnChips.length > 0 ? _react.default.createElement("div", {
        className: "drag-chips-box-style",
        "data-container": "column-box"
      }, _react.default.createElement("div", {
        className: "column-chips-style"
      }, selectedColumnChips.map(function (data, index) {
        return _react.default.createElement("div", {
          className: "chip-container",
          onDragOver: _this2.dragOver
        }, _react.default.createElement(_reactComponents.Tag, {
          value: data.label,
          "data-id": index,
          "data-value": JSON.stringify(data),
          "data-category": "column",
          "data-container": "chips",
          key: data.label,
          removable: true,
          draggable: "true",
          onRemoveClick: _this2.handleColumnChipDelete(data),
          onDragEnd: _this2.dragWithinContainerEnd,
          onDragStart: _this2.dragWithinContainerStart
        }));
      })), maxSelectedColumnsExceeded ? _react.default.createElement("div", null, _react.default.createElement("span", {
        className: "max-size-exceeded"
      }, maxSelectedColumnsExceeded)) : null) : _react.default.createElement("div", {
        className: "drag-box",
        "data-container": "column-box"
      }, "Drag Here", _react.default.createElement("br", null), _react.default.createElement("span", {
        className: "drag-box-max"
      }, "(Max Allowed : 1)")))))), showQuantity ? _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement(_reactComponents.Tooltip, {
        direction: "right",
        contents: quantityToolTip,
        className: "custom-tooltip"
      }, _react.default.createElement("div", {
        className: "selection-box"
      }, _react.default.createElement(_reactComponents.TextField, {
        name: "required",
        label: "Quantity",
        value: selectedQuantity,
        onChange: this.onQuantityChange,
        helpText: quantityHelpText || 'Enter a quantity for pivoting',
        bsStyle: quantityStyle || null,
        required: true
      })))) : null))))), _react.default.createElement("div", {
        className: "col-md-5"
      }, _react.default.createElement(_Paper.default, {
        className: "pivot-panel-paper"
      }, _react.default.createElement("div", {
        className: "pivot-configuration"
      }, _react.default.createElement("div", {
        className: "row pivot-configuration-heading"
      }, _react.default.createElement("div", {
        className: "heading-container"
      }, _react.default.createElement(_reactComponents.Icon, {
        color: colors.teal.base,
        name: "filter-2-l",
        size: "1x"
      }), _react.default.createElement("h5", {
        className: "filter-text-style"
      }, "Filter "))), _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-12"
      }, _react.default.createElement(_reactComponents.Select, {
        label: "Select Attribute",
        value: selectedAttributeInFilter,
        options: attributeFilterArray,
        onChange: this.onSelectedConfigAttributeChange,
        tether: true,
        helpText: attributeFilterArray.length > 0 ? 'Select an attribute for filtering.' : 'No attribute selected. Select an attribute for filtering values.'
      }))), selectedAttributeInFilter ? _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-md-12 attribute-values-container"
      }, !selectedAttributeInFilter.isRange ? _react.default.createElement(_reactComponents.Select, {
        label: "Select Values",
        className: "list-values-style",
        value: inputListValue,
        options: selectedAttributeInFilter.values.map(function (val) {
          var ob = {
            label: val,
            value: val
          };
          return ob;
        }),
        onChange: this.onSelectedListValuesChange,
        tether: true,
        helpText: listValuesHelpText || 'Select values for attribute pivoting.'
      }) : _react.default.createElement("div", null, _react.default.createElement(_reactComponents.Tooltip, {
        direction: "right",
        contents: selectedAttributeInFilter.toolTip,
        className: "custom-tooltip"
      }, _react.default.createElement(_reactComponents.TextField, {
        name: "normal",
        label: "Enter Value",
        type: "number",
        step: "0.01",
        className: "input-error-box",
        value: inputRangeValue,
        bsStyle: inputRangeStyle || null,
        rightAddon: _react.default.createElement("button", {
          onClick: function onClick() {
            return _this2.addInputToSelectedRangeValues();
          },
          className: "btn btn-default",
          disabled: inputRangeStyle === 'error' || !inputRangeValue
        }, "ADD"),
        onChange: this.onSelectedRangeValuesChange,
        helpText: rangeValuesHelpText || null
      }))), _react.default.createElement("div", null, selectedAttributeValues ? _react.default.createElement("div", {
        className: "values-box-style"
      }, selectedAttributeValues.map(function (val) {
        return _react.default.createElement(_reactComponents.Tag, {
          value: val,
          key: val,
          removable: true,
          onRemoveClick: _this2.onRemoveSelectedValueChip
        });
      })) : null), selectedValuesHelpText ? _react.default.createElement("span", {
        className: "help-box"
      }, selectedValuesHelpText) : null)) : null)))))), _react.default.createElement("div", {
        className: "grid-wrapper-style",
        id: "grid-wrapper"
      }, showDropdown ? _react.default.createElement("div", {
        className: "pivot-dropdown"
      }, _react.default.createElement(_reactComponents.Dropdown, {
        title: selected ? selected.toUpperCase() : ' ',
        className: "drop-down-style"
      }, dropdownOptions.map(function (value) {
        return _react.default.createElement("a", {
          key: value,
          onClick: function onClick() {
            return _this2.onDropdownSelection(value);
          }
        }, value.toUpperCase());
      }))) : null, _react.default.createElement("div", {
        className: "ag-theme-balham ag-grid-custom-style"
      }, _react.default.createElement(_agGridReact.AgGridReact, {
        className: "pivot-grid",
        columnDefs: columnArray,
        rowData: this.state.rowData,
        rowHeight: 40,
        showLoadingOverlay: true,
        showNoRowsOverLay: true,
        enableFilter: true,
        enableSorting: true,
        gridAutoHeight: true,
        rowDragManaged: true,
        animateRows: true,
        enableColResize: true,
        defaultColDef: defaultColDef,
        onSelectionChanged: this.onSelectionChanged,
        onGridReady: this.onGridReady,
        onDisplayedColumnsChanged: this.onDisplayedColumnsChanged,
        frameworkComponents: frameworkComponents,
        loadingOverlayComponent: loadingOverlayComponent
      }))));
    }
  }]);
  return PivotConfigurationPanel;
}(_react.Component);

exports.default = PivotConfigurationPanel;